module.exports = __webpack_public_path__ + "static/company-5a657f6f4a2fd16272175ad6a448893c.jpg";